import { createSlice } from "@reduxjs/toolkit";
import { registerPatient } from "../../reducer/patientRegister/patientRegisterReducer";

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const patientRegisterSlice = createSlice({
  name: "patientRegister",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(registerPatient.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(registerPatient.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(registerPatient.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default patientRegisterSlice.reducer;
